import { mapServerToFrameVariant } from "../../../../variant-mappers/mappers/server-to-client/variant-mappers/map-server-to-frame-variant.js";
import { mapServerToProductBase } from "./map-server-to-product-base.js";
import { getOfferings } from "../../../../utils/mappers/server-to-client/utils/get-offerings.js";
const mapServerToFramesProduct = (serverProduct, slug, locale, facetConfigList, flatFacetConfigList, priceSegmentChannelKey) => {
  if (serverProduct?.__typename !== "FrameProduct") {
    return {
      failure: "incorrect-typename",
      message: `Expected FrameProduct for slug "${slug}", but got ${serverProduct?.__typename}`
    };
  }
  const variants = mapServerToFrameVariant(serverProduct, slug, locale, priceSegmentChannelKey);
  if (!variants || variants.length === 0) {
    return {
      failure: "no-variants",
      message: `Cannot return Frames product with slug: "${slug}" because it has no variants`
    };
  }
  return {
    ...mapServerToProductBase(serverProduct, variants, facetConfigList, flatFacetConfigList),
    productType: "Frames",
    variants,
    offerings: getOfferings(serverProduct.productTypeDetails.offerings, locale),
    isOfferedWithPrescriptions: !!serverProduct.productTypeDetails.isOfferedWithPrescriptions,
    isExclusiveBrand: serverProduct.productTypeDetails.isExclusiveBrand ?? void 0
  };
};
export {
  mapServerToFramesProduct
};
//# sourceMappingURL=map-server-to-frame-product.js.map
